module.exports = __webpack_public_path__ + "img/login-background.e24af02.png";